var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkmode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic32/darkmode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2016 10.6C25.6 13.7903 25.5995 18.2118 23.2001 21.4016M15.9999 25C17.4138 25 18.7516 24.6739 19.9422 24.0929C19.8287 24.0976 19.7145 24.1 19.5999 24.1C15.1264 24.1 11.5 20.4735 11.5 16C11.5 11.5265 15.1264 7.9 19.5999 7.9C19.7145 7.9 19.8287 7.90238 19.9422 7.9071C18.7516 7.32606 17.4138 7 15.9999 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 15.9999 25Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmode);
export default __webpack_public_path__ + "static/media/darkmode.7583ca4d558a9867f93590ee2838d7a4.svg";
export { ForwardRef as ReactComponent };